/// <reference path="../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox {

    @Serenity.Decorators.registerClass()
    export class ChatmessagesCameraDialog extends NoboxEntityDialog<ChatmessagessCameraForm, any> {
        protected getFormKey() { return ChatmessagessCameraForm.formKey; }

        protected form = new ChatmessagessCameraForm(this.idPrefix);
        public msg = "";
        public srcImg = "";
        public setCam = 1;
        constructor(container?: JQuery) {
            super(container);
            var $this = this;
            setTimeout(function () {
                $this.dialogTitle = "Take a photo";
            }, 0)
            this.element.find(".s-DialogToolbar").height(0);
            $('<a class="inplace-button inplace-action3"><b><i class="fa fa-paper-plane text-primary"></i></b></a>')
                .attr("title", "Send a images message")
                .insertAfter(this.form.Msg.element)
                .click(e => {
                    //$(".send-file").click()
                });
        }
        protected updateInterface() {
            super.updateInterface();
            this.form.Msg.element.keyup(function (e) {
                if (e.keyCode == 13) {
                    $(".send-file").click();
                }
            })
        }
        protected save() {
            this.form.Type.value = '5';
            this.form.Ack.value = 2;
            this.msg = this.form.Msg.value;
            super.save();
        }

        protected getToolbarButtons() {
            var $this = this;
            var buttons = super.getToolbarButtons();
            buttons[0].hint = "Send";
            buttons[0].title = "Send";
            buttons[0].visible = false;
            buttons[0].cssClass = "send-file";
            buttons[0].icon = 'fa fa-paper-plane';
            buttons[1].visible = false;
            buttons[2].visible = false;
            buttons[3].visible = false;
            buttons[4].visible = false;
            buttons[5].visible = false;
            return buttons;
        }

        protected onDialogClose() {
            Webcam.reset();
        }

        protected onDialogOpen() {
            var Mediawidth = 200, Mediaheight = 140;
            if (window.innerHeight > window.innerWidth) {
                Mediawidth = 140; Mediaheight = 200;
            } else {
                Mediawidth = 200; Mediaheight = 140;
            }
            //this.form.Files.element.html(`<div class="row"><div class="col">    
            //            <div id="webcamContent" style="margin: 0 auto; display: block; border-radius:5px;"></div>
            //            <div style="text-align: center; font-size: larger;" class="text-dark mt-1">
            //                <div id="btnCapture" class="lkbtn lkbtn-dim lkbtn-small lkbtn-primary p-1">Capture</div>
            //        </div></div><div class="col"
            //            <div id="imgCapture">
                              
            //            </div>
            //        </div></div>`)
            //this.form.Files.element.html(`Indro ni bos`)
            super.onDialogOpen();
        }

        protected onSaveSuccess(response) {
            //function createEntFile(id,type, msg, file, reply) {
            //    return {
            //        Id:id,
            //        RoomId: $(".nk-chat-body").attr("data-id"),
            //        Ack: 2,
            //        From: $(".nk-chat-body").attr("data-user-from"),
            //        To: $(".nk-chat-body").attr("data-user-to"),
            //        AgentId: $(".nk-chat-body").attr("data-ag-id"),
            //        Type: type.toString(),
            //        Msg: msg,
            //        Files: file,
            //        ReplyId: reply,
            //        In: new Date().toISOString(),
            //        InBy: $(".nk-chat-body").attr("data-ag-id"),
            //        Up: new Date().toISOString(),
            //        UpBy: $(".nk-chat-body").attr("data-ag-id"),
            //        SdrMsg: 'me'
            //    }
            //}
            //Nobox.ChatmessagesService.Retrieve({
            //    EntityId: BigInt(response.EntityId).toString()
            //}, resFile => {
            //    if (window.ArrAgents.filter(b => b.UserId == $('.nk-chat-body').attr('data-ag-id')).length < 1) {
            //        Nobox.ChatroomagentsService.Create({
            //            Entity: {
            //                RoomId: $(".nk-chat-body").attr("data-id"),
            //                UserId: $(".nk-chat-body").attr("data-ag-id"),
            //                DisplayName: $(".nk-chat-body").attr("data-ag-nm"),
            //                UserImage: $(".nk-chat-body").attr("data-ag-img"),
            //            }
            //        }, res => {
            //            sendMsg(JSON.stringify([{ Type: 'Msg', RoomId: $(".nk-chat-body").attr("data-id"), Entity: createEntFile(BigInt(response.EntityId).toString(), 5, resFile.Entity.Msg, resFile.Entity.Files, null), Icon: '<i class="fa fa-image"></i> ' }]), $(".nk-chat-body").attr("data-id"));
            //        })
            //    } else {
            //        sendMsg(JSON.stringify([{ Type: 'Msg', RoomId: $(".nk-chat-body").attr("data-id"), Entity: createEntFile(BigInt(response.EntityId).toString(), 5, resFile.Entity.Msg, resFile.Entity.Files, null), Icon: '<i class="fa fa-image"></i> ' }]), $(".nk-chat-body").attr("data-id"));
            //    }
            //    Nobox.ChatroomsService.Update({
            //        EntityId: $('.nk-chat-body').attr('data-id'),
            //        Entity: {
            //            LastMsg: `<i class="fa fa-file"></i> ` + resFile.Entity.Msg,
            //            TimeMsg: new Date().toISOString(),
            //            SdrMsg: 'me'
            //        }
            //    })
            //})
            super.onSaveSuccess(response);

            Serenity.SubDialogHelper.triggerDataChange(this);   // *** Refreshing the parent grid ***
            this.dialogClose();    // *** Closing the dialog ***
        }
    }
}